import "./MorrowServiceArea.module.css";
import Header from "@/reusable_sections/Header";
import MorrowHero from "./sections/MorrowHero";
import Morrow from "./sections/Morrow";
import ServicesGrid from "./sections/ServicesGrid";
import PlumbingIssues from "./sections/PlumbingIssues";
import MorrowFaq from "./sections/MorrowFaq";
import MorrowClosing from "./sections/MorrowClosing";
import Footer from "@/reusable_sections/Footer";
export default function MorrowServiceAreaPage() {
  return <div>
      <Header />
      <MorrowHero />
      <Morrow />
      <ServicesGrid />
      <PlumbingIssues />
      <MorrowFaq />
      <MorrowClosing />
      <Footer />
    </div>;
}